import { render, staticRenderFns } from "./english-small-start-effect-evaluation.vue?vue&type=template&id=09d96ef2&"
import script from "./english-small-start-effect-evaluation.vue?vue&type=script&lang=js&"
export * from "./english-small-start-effect-evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports